// Partner referral links.
// Paste your personal SoFi referral URL here.
// Grab it from: SoFi app → Profile → Invite Friends → Banking → Share link.
export const SOFI_REFERRAL_URL = "https://www.sofi.com/invite/money?gcp=ecab4709-33b5-4041-af7f-de20d6345451&isAliasGcp=false";

// SoFi Checking & Savings referral rewards (as of May 2026):
//   You earn $75 ($100 SoFi+) per referral.
//   Friend earns $25, plus up to $400 with direct deposit.
//   Paid as reward points, not cash.
